import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import "./App.css";
import Footer from "./component/Footer/Footer";

import About from "./pages/About/About";

import Home from "./pages/Home/Home";

import { useEffect, useLayoutEffect, useState } from "react";
import Navbar from "./component/Navbar/Navbar";

import PageNotFound from "./pages/404/404";

import CookieConsent from "react-cookie-consent";
import Subscribe from "./component/Subscribe/Subscribe";
import DataP from "./pages/DataP/DataP";
import Collaboration from "./pages/Collaboration/Collaboration";
import SandA from "./pages/SandA/SandA";
import Membership from "./pages/Membership/Membership";
import Login from "./pages/Auth/Login";
import Signup from "./pages/Auth/Signup";
import ForgotPassword from "./pages/Auth/ForgotPassword";
import UserDash from "./pages/Auth/UserDash";

function App() {
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 200);
  }, []);

  useEffect(() => {
    setScrollF(true);
  }, 5000);

  const Wrapper = ({ children }) => {
    const location = useLocation();
    useLayoutEffect(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
      // document.documentElement.scrollTo(0, 0);
    }, [location.pathname]);
    return children;
  };
  const [scrollF, setScrollF] = useState(false);

  const listenToScroll = function () {
    var y = window.scrollY;
    if (y >= 1000) {
      setScrollF(true);
    }
  };
  window.addEventListener("scroll", listenToScroll);

  return (
    <BrowserRouter>
      <div className="App">
        {loading ? (
          ""
        ) : (
          <Wrapper>
            <Subscribe />
            <Navbar />
            <Routes>
              <Route index element={<Home />} />
              <Route
                path={`${process.env.PUBLIC_URL}/about`}
                element={<About />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/data-protection`}
                element={<DataP />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/collaboration`}
                element={<Collaboration />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/sdgs-and-alignment`}
                element={<SandA />}
              />{" "}
              <Route
                path={`${process.env.PUBLIC_URL}/membership`}
                element={<Membership />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/login`}
                element={<Login />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/register`}
                element={<Signup />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/forgot-password`}
                element={<ForgotPassword />}
              />
              <Route
                path={`${process.env.PUBLIC_URL}/account`}
                element={<UserDash />}
              />
              <Route path="*" element={<PageNotFound />} />
            </Routes>
            {/* <a href="https://wa.me/2348023358188" class="float" target="_blank">
              <i class="fab fa-whatsapp my-float"></i>
            </a> */}
            {/* <Footer /> */}
          </Wrapper>
        )}
      </div>
      {scrollF ? (
        <CookieConsent
          overlay
          disableScroll
          buttonText="Accept"
          cookieName="myAwesomeCookieName2"
          containerClasses=""
          buttonStyle={{
            background: "#f99f30",
            color: "white",
            fontWeight: "bold",
            fontSize: "15px",
            padding: "10px 50px",
          }}
          expires={150}
        >
          TThe DataProSDGs Website uses cookies to make your online experience
          easier and better. You consent to use our cookies.{" "}
          {/* <span style={{ fontSize: "10px" }}>This bit of text is smaller :O</span> */}
        </CookieConsent>
      ) : (
        ""
      )}
    </BrowserRouter>
  );
}

export default App;
